module.exports = __webpack_public_path__ + "static/media/10.f3a5d25b.JPG";